var exports = {
  "kL": "xfd349460--aa3327--container",
  "AS": "xfd349460--aa3327--item",
  "Pf": "xfd349460--aa3327--label",
};

module.exports = exports;
